<template>
  <v-container class="fill-height pb-0">
    <v-card class="e-cardLeccion-final e-elevation--4 e-border--radius fill-height">
      <v-card-title class="e-cardLeccion-final-title verde-azul pb-0 justify-center">
        <div class="e-cardLeccion-final-title-bg">
          <img src="../../../assets/images/gramatica/Gato.gif" alt="Personaje leccion"/>
        </div>
        <img src="../../../assets/images/gramatica/award.png" alt="Personaje leccion" class="e-cardLeccion-final-title-award"/>
      </v-card-title>
      <v-card-text class="e-cardLeccion-final-text px-4 align-center d-flex justify-end">
        <div class="pt-3">
          <p class="e-sub-sub-title-md mb-0"> {{ descripcion }}</p>
          <v-btn
          class="mt-3 elevation-0"
          block
          round
          large
          router-link
          :to="route"
          color="verde-azul white--text">
            CONTINUAR
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'cardFin',
  props: {
    descripcion: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    }
  }
}
</script>
